import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-combo-box',
  templateUrl: './combo-box.component.html',
  styleUrls: ['./combo-box.component.css']
})
export class ComboBoxComponent implements OnInit {
  
  @Input() set options(options: Array<string>){
    this.sortedOptions = [];
    for(let x=0; x < options.length; x++){
      this.sortedOptions.push({value: options[x], index: x});
    }
    this.sortedOptions.sort((a, b) => {
      if(a.value < b.value){
        return -1;
      }else{
        return 1;
      }
    });
    console.log("combo options: ", this.sortedOptions);
  };

  sortedOptions: Array<any> = [];           // array of {value: '', index: -1} objects sorted by the value key. index is
                                            // the original index of the value within the input array.
  filteredOptions: Array<any> = [];         // a reduced list of sorted options. Only options in the filtered list 
                                            // can be displayed in the dropdown
  @Input() allowDropdownStretch: boolean = false;           // lets the dropdown be as wide as its contents                
  @Input() value: string = '';                              // the value in the text field
  @Input() allowCustomValue: boolean = true;                // allow user to create a custom output value
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<any>();          // the emits every time value is changed
  @Output() indexChange = new EventEmitter<any>();          // emits the index of the selected option
  @Output() valueSelect = new EventEmitter<any>();          // emits the value only when a selection is made (dropdown or enter)
  showDropDown: boolean = false;
  index: number = -1;

  constructor() { }

  ngOnInit() {
    this.filterOptions();
  }

  logMe(data:any){
    console.log(data);
  }

  dropDownSelect(item: any){
    this.value = item.value;
    this.valueChange.emit(this.value);
    this.index = item.index;
    this.indexChange.emit(this.index);
    this.valueSelect.emit(item);
    this.showDropDown = false;
  }

  filterOptions(){
    this.filteredOptions = [];
    for(let x = 0; x < this.sortedOptions.length; x++){
      if(this.sortedOptions[x]['value'].toLowerCase().includes(this.value.toLowerCase())){
        this.filteredOptions.push(this.sortedOptions[x]);
      }
    }
  }

  onKey(event: any){
    // enter
    if(event.keyCode == 13){
      this.showDropDown = false;
      event.target.blur();
      if(this.allowCustomValue){
        this.valueSelect.emit({value: this.value, index: this.index});
      }
      else if(this.filteredOptions.length != 0){
        console.log("selected by enter: ", this.filteredOptions[0]);
        this.dropDownSelect(this.filteredOptions[0]);
      }
    }
    // typing
    else{
      this.showDropDown = true;
    }
  }

  onButton(){
    this.showDropDown = !this.showDropDown;
    this.filteredOptions = JSON.parse(JSON.stringify(this.sortedOptions));
  }

  handleChange(){
    this.filterOptions(); 
    if(this.allowCustomValue){
      this.valueChange.emit(this.value); 
      this.index = -1;
    }
  }

}
